export default {"src":"/_next/static/media/location_visits_3.fd0701ac.gif","height":400,"width":700,"blurWidth":0,"blurHeight":0};